var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 92,
    viewBox: "0 0 114 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeWidth: 4,
    d: "M57.516 89.342L70.408 76.45h34.21a7 7 0 0 0 7-7V9a7 7 0 0 0-7-7H9a7 7 0 0 0-7 7v60.45a7 7 0 0 0 7 7h34.21l12.892 12.892a1 1 0 0 0 1.414 0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 41.672v4.146a18.94 18.94 0 0 0-9.428 6.419 2 2 0 0 1-3.144-2.474A22.954 22.954 0 0 1 52 41.673zm10-.25a22.962 22.962 0 0 1 13.558 8.149 2 2 0 1 1-3.116 2.507A18.951 18.951 0 0 0 62 45.512v-4.09zM62 30.35v-4.037c8.533 1.091 16.384 5.001 22.421 11.098a2 2 0 1 1-2.842 2.814C76.287 34.882 69.448 31.415 62 30.35zm-10 .024c-7.452 1.105-14.291 4.622-19.57 10.024a2 2 0 1 1-2.86-2.796C35.595 31.436 43.455 27.468 52 26.335v4.039z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.022 57A4 4 0 0 0 53 60.978c-.001.223.02.44.054.654a3.997 3.997 0 0 0 7.946-.61A4 4 0 0 0 57.022 57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M55 16a2 2 0 1 1 4 0v35a2 2 0 1 1-4 0V16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.1d112cb034100b45d9b88df94bbbdb76.svg";
export { ForwardRef as ReactComponent };